
export const MESSAGE_DIRECTIONS = {
    USER: 'user',
    SUPPORT: 'support'
};

export const messageDirectionItems = [
    MESSAGE_DIRECTIONS.USER,
    MESSAGE_DIRECTIONS.SUPPORT
];

